import api from "./services/api";

export async function subscribeUserToPush(user) {
    if (!("serviceWorker" in navigator && "PushManager" in window)) return;

    const registration = await navigator.serviceWorker.ready;
    const vapidPublicKey = localStorage.getItem("vapidPublicKey");
    if (!vapidPublicKey) return;
    const vapidPublicKeyParsed = JSON.parse(vapidPublicKey);
    const convertedVapidKey = urlBase64ToUint8Array(vapidPublicKeyParsed);

    try {
        const subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: convertedVapidKey,
        });

        await api.post("/push", {
            userId: user.id,
            subscription: JSON.stringify(subscription),
            
        });

        //console.log("User is subscribed:", subscription);
        // Send subscription to server
    } catch (error) {
        console.error("Failed to subscribe the user: ", error);
    }
}

function urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    const rawData = window.atob(base64);
    return Uint8Array.from(rawData, (c) => c.charCodeAt(0));
}